/* AzureBones theme
   - Drawers: cart, mobile menu, search
   - Cart: Shopify Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js)
   - Product: variant picker, gallery, quantity, add to cart
   - Search: predictive search (/search/suggest.json)
   - Collection: sort select
   - Home: advent countdown doors */

(function () {
  'use strict';

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const T = window.theme || { routes: {} };
  const R = Object.assign({ root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictiveSearch: '/search/suggest', allProducts: '/collections/all' }, T.routes);

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || T.moneyFormat || '${{amount}}';
    const delimit = (n, precision, thousands, decimal) => {
      if (isNaN(n) || n == null) return '0';
      const parts = (n / 100).toFixed(precision).split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    };
    const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return fmt;
    let value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  const sizedImage = (url, width) => {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  };

  const shortTitle = (title) => String(title || '').split(' – ')[0].split(' — ')[0].split(' - ')[0].split(', ')[0].split(' | ')[0].trim();

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  const scrim = () => $('[data-scrim]');

  function openPanel(el) {
    if (!el) return;
    closePanels(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (!el.classList.contains('search-panel') && scrim()) scrim().classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('input, button, a');
    setTimeout(() => f && f.focus(), 60);
  }

  function closePanels(silent) {
    $$('.drawer.is-open, .search-panel.is-open').forEach((el) => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    if (scrim()) scrim().classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Cart ---------- */
  let cartState = null;
  try { cartState = JSON.parse(($('#cart-json') || {}).textContent || 'null'); } catch (e) { cartState = null; }

  function renderCart(cart) {
    if (cart) cartState = cart;
    const c = cartState;
    if (!c) return;
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = c.item_count > 0 ? c.item_count : '';
      el.dataset.count = c.item_count;
    });
    const body = $('#cart-items');
    const foot = $('#cart-foot');
    if (!body) return;
    if (!c.items.length) {
      body.innerHTML = '<div class="empty-cart"><p>Your cart is empty.</p><a class="btn btn-ghost" href="' + esc(R.allProducts) + '">Browse the shop</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = c.items.map((item, i) => {
      const line = i + 1;
      const variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
      const img = item.image ? '<img class="cut" src="' + esc(sizedImage(item.image, 200)) + '" alt="" loading="lazy" width="76" height="76">' : '';
      return '<div class="line-item">' +
        '<a href="' + esc(item.url) + '">' + img + '</a>' +
        '<div>' +
          '<h3><a href="' + esc(item.url) + '">' + esc(shortTitle(item.product_title)) + '</a></h3>' +
          (variant ? '<p class="variant">' + esc(variant) + '</p>' : '') +
          '<div class="qty" role="group" aria-label="Quantity for ' + esc(shortTitle(item.product_title)) + '">' +
            '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
          '</div>' +
          '<div><button type="button" class="remove" data-line="' + line + '" data-qty="0">Remove</button></div>' +
        '</div>' +
        '<span class="price">' + formatMoney(item.final_line_price) + '</span>' +
      '</div>';
    }).join('');
    const sub = $('#cart-subtotal');
    if (sub) sub.textContent = formatMoney(c.total_price);
  }

  async function fetchCart() {
    const res = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  async function addToCart(id, quantity) {
    const res = await fetch(R.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'This item couldn’t be added. Try again.');
    }
    return fetchCart();
  }

  async function changeLine(line, quantity) {
    const body = $('#cart-items');
    if (body) body.style.opacity = '.5';
    try {
      const res = await fetch(R.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
      });
      const cart = await res.json();
      if (!res.ok || cart.status) throw new Error(cart.description || 'Cart could not be updated.');
      renderCart(cart);
    } catch (e) {
      toast(e.message);
      fetchCart();
    } finally {
      if (body) body.style.opacity = '';
    }
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-shown');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-shown'), 2600);
  }

  /* ---------- Global clicks ---------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    if (open) {
      const target = document.getElementById(open.dataset.open);
      if (target) {
        e.preventDefault();
        openPanel(target);
      }
      return;
    }
    if (e.target.closest('[data-close]') || e.target.matches('[data-scrim]')) {
      closePanels();
      return;
    }
    const line = e.target.closest('#cart-items [data-line]');
    if (line) changeLine(line.dataset.line, line.dataset.qty);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanels(); });

  /* Quick add from product cards */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    try {
      await addToCart(form.elements.id.value, 1);
      openPanel($('#cart'));
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* ---------- Predictive search ---------- */
  function initSearch() {
    const input = $('[data-predictive-search]');
    const out = $('#search-results');
    if (!input || !out) return;
    let timer;
    let controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) return;
      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        try {
          const url = R.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: controller ? controller.signal : undefined });
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          out.innerHTML = products.length
            ? products.map((p) => {
                const img = p.featured_image && p.featured_image.url ? '<img class="cut" src="' + esc(sizedImage(p.featured_image.url, 160)) + '" alt="" loading="lazy">' : '<span></span>';
                const toCents = (x) => Math.round(Number(x) * 100);
                const price = p.price_min != null && p.price_min !== p.price_max ? 'From ' + formatMoney(toCents(p.price_min)) : formatMoney(toCents(p.price));
                return '<a class="search-hit" href="' + esc(p.url) + '">' + img + '<span>' + esc(shortTitle(p.title)) + '</span><span class="price muted">' + esc(price) + '</span></a>';
              }).join('')
            : '<p class="search-empty">Nothing matches “' + esc(q) + '”. Try amp, fidget or bookmark.</p>';
        } catch (err) {
          if (err.name !== 'AbortError') out.innerHTML = '<p class="search-empty">Search isn’t responding. Press Enter to see full results.</p>';
        }
      }, 180);
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';

    let data = { variants: [], options: [] };
    try { data = JSON.parse(root.querySelector('[data-product-json]').textContent); } catch (e) { /* no variant data */ }

    const form = root.querySelector('[data-product-form]');
    const idInput = root.querySelector('[data-variant-id]');
    const addBtns = $$('[data-add-button]', root);
    const priceEls = $$('[data-price]', root);
    const compareEl = root.querySelector('[data-compare-price]');
    const errorEl = root.querySelector('[data-form-error]');
    const qtyInput = root.querySelector('[data-qty-input]');

    /* Gallery */
    const thumbs = $$('[data-thumb]', root);
    const stageImg = root.querySelector('#stage-img');
    const counter = root.querySelector('[data-stage-count]');
    let index = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));

    function show(i) {
      if (!thumbs.length || !stageImg) return;
      index = (i + thumbs.length) % thumbs.length;
      const t = thumbs[index];
      stageImg.classList.remove('swap');
      void stageImg.offsetWidth;
      stageImg.classList.add('swap');
      stageImg.srcset = t.dataset.srcset;
      stageImg.src = t.dataset.src;
      stageImg.alt = t.dataset.alt || '';
      if (counter) counter.textContent = (index + 1) + ' / ' + thumbs.length;
      thumbs.forEach((x, k) => x.setAttribute('aria-current', String(k === index)));
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => show(index - 1));
    if (next) next.addEventListener('click', () => show(index + 1));
    if (counter && thumbs.length) counter.textContent = (index + 1) + ' / ' + thumbs.length;

    const stage = root.querySelector('.stage');
    let sx = null;
    if (stage) {
      stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (sx == null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }

    /* Variant picker */
    const optionButtons = $$('[data-option-index]', root);
    const selected = data.options.map((_, i) => {
      const on = root.querySelector('[data-option-index="' + i + '"][aria-checked="true"]');
      return on ? on.dataset.value : null;
    });

    const findVariant = (sel) => data.variants.find((v) => v.options.every((o, i) => o === sel[i]));

    function markAvailability() {
      optionButtons.forEach((b) => {
        const i = Number(b.dataset.optionIndex);
        const trial = selected.slice();
        trial[i] = b.dataset.value;
        const v = findVariant(trial);
        b.classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function update(changedIndex) {
      optionButtons.forEach((b) => b.setAttribute('aria-checked', String(b.dataset.value === selected[Number(b.dataset.optionIndex)])));
      $$('[data-option-label]', root).forEach((el) => { el.textContent = selected[Number(el.dataset.optionLabel)] || ''; });
      markAvailability();
      const v = findVariant(selected);
      if (errorEl) errorEl.textContent = '';
      if (!v) {
        addBtns.forEach((b) => { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      priceEls.forEach((el) => { el.textContent = formatMoney(v.price); });
      if (compareEl) {
        compareEl.hidden = !(v.compare_at_price > v.price);
        if (v.compare_at_price) compareEl.textContent = formatMoney(v.compare_at_price);
      }
      addBtns.forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      if (changedIndex != null && v.featured_media) {
        const k = thumbs.findIndex((t) => Number(t.dataset.mediaId) === Number(v.featured_media.id));
        if (k > -1 && k !== index) show(k);
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    optionButtons.forEach((b) => b.addEventListener('click', () => {
      const i = Number(b.dataset.optionIndex);
      selected[i] = b.dataset.value;
      update(i);
    }));
    if (optionButtons.length) markAvailability();

    /* Quantity */
    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');
    const clamp = (n) => Math.min(99, Math.max(1, Math.round(Number(n)) || 1));
    if (minus) minus.addEventListener('click', () => { qtyInput.value = clamp(Number(qtyInput.value) - 1); });
    if (plus) plus.addEventListener('click', () => { qtyInput.value = clamp(Number(qtyInput.value) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', () => { qtyInput.value = clamp(qtyInput.value); });

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const label = addBtns.map((b) => b.textContent);
        addBtns.forEach((b) => { b.disabled = true; b.textContent = 'Adding…'; });
        if (errorEl) errorEl.textContent = '';
        try {
          await addToCart(idInput.value, qtyInput ? clamp(qtyInput.value) : 1);
          openPanel($('#cart'));
        } catch (err) {
          if (errorEl) errorEl.textContent = err.message;
        } finally {
          addBtns.forEach((b, k) => { b.disabled = false; b.textContent = label[k]; });
          const v = findVariant(selected) || data.variants.find((x) => String(x.id) === String(idInput.value));
          if (v && !v.available) addBtns.forEach((b) => { b.disabled = true; b.textContent = 'Sold out'; });
        }
      });
    }

    /* Sticky mobile bar once the main button scrolls away */
    const bar = root.querySelector('[data-mobile-buy]');
    const mainBtn = form ? form.querySelector('[data-add-button]') : null;
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        bar.classList.toggle('is-shown', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(mainBtn);
    }
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    $$('[data-sort-by]').forEach((sel) => {
      sel.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Advent doors ---------- */
  function initDoors() {
    $$('[data-doors]').forEach((doors) => {
      const cap = doors.parentElement.querySelector('[data-doors-caption]');
      const now = new Date();
      const inDec = now.getMonth() === 11;
      const day = inDec ? now.getDate() : 0;
      $$('i', doors).forEach((d, i) => {
        d.className = i + 1 < day ? 'open' : i + 1 === day ? 'today' : '';
      });
      if (!cap) return;
      if (inDec && day <= 24) cap.textContent = 'Door ' + day + ' of 24 opens today';
      else if (inDec) cap.textContent = 'All 24 doors open. See you next year.';
      else {
        const start = new Date(now.getFullYear(), 11, 1);
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const days = Math.ceil((start - today) / 864e5);
        cap.textContent = days + (days === 1 ? ' day' : ' days') + ' until door 1';
      }
    });
  }

  /* ---------- Boot ---------- */
  function init(scope) {
    $$('[data-product]', scope).forEach(initProduct);
    initDoors();
  }

  document.addEventListener('DOMContentLoaded', () => {
    renderCart();
    initSearch();
    initSort();
    init(document);
  });

  /* Theme editor: re-run section scripts when a section is edited */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
